export default __webpack_public_path__ + "static/media/brand-hort-colour.bbaf66a3.svg";